import React__default, { useRef } from 'react';
import styled, { css } from 'styled-components';
import { i as isMobile } from '../../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';
import { P as PopoverScrollContainer, a as PopoverContent, C as ChildrenWrapper } from './PopoverContentContainer.styles-D55vrXWe.js';
import { P as PortalComponent } from '../../Portal/PortalComponent-BUtFB9XK.js';
import { P as PortalContextProvider } from '../../Portal/PortalContext-CNkIMMvm.js';
import { F as Flex } from '../../Flex/Flex-Bu--MFcy.js';
import { C as CloseButton } from '../../Button/CloseButton/CloseButton-C6GGkrSs.js';

// added negative margin to shift close button up
const StyledCloseButton = /*#__PURE__*/styled(CloseButton).withConfig({
  componentId: "sc-storm-ui-40020072__sc-198izy4-0"
})(["margin-block-start:-", ";", ""], ({
  theme
}) => theme.spacing.xxxxsmall.default, isMobile(css(["margin-block-start:-", ";"], ({
  theme
}) => theme.spacing.xxxxsmall.mobile)));
const PopoverContentContainer = ({
  children,
  closeButtonLabel,
  handleCloseClicked,
  footer,
  padding = 'base',
  variant = 'default',
  withCloseButton
}) => {
  const portalRef = useRef(null);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(PopoverScrollContainer, null, /*#__PURE__*/React__default.createElement(PortalContextProvider, {
    portalElementRef: portalRef
  }, /*#__PURE__*/React__default.createElement(PopoverContent, {
    $padding: padding
  }, /*#__PURE__*/React__default.createElement(Flex, {
    columnGap: "xsmall"
  }, /*#__PURE__*/React__default.createElement(ChildrenWrapper, null, children), withCloseButton && /*#__PURE__*/React__default.createElement(StyledCloseButton, {
    label: closeButtonLabel,
    onClick: handleCloseClicked,
    inverted: variant !== 'default',
    size: "small"
  })), footer && /*#__PURE__*/React__default.createElement(Flex, null, footer)))), /*#__PURE__*/React__default.createElement(PortalComponent, {
    ref: portalRef
  }));
};

export { PopoverContentContainer as P };
//# sourceMappingURL=PopoverContentContainer-reJ6aXGa.js.map
